import { ShopCode } from '@/utils/shop'
import { ABTestInputCondition, abTestGlobalKey } from '../abtestV2'

export const PDP_LEVERSPHERE_LOOP_EXPERIMENT_CAMPAIGN: ABTestInputCondition = {
  code: 'pdp_leversphere_loop_campaign',
  exprId: 'pdp_leversphere_loop',
  exprName: 'PDP Combo Pack For Ornament Product UI Experiment',

  startDate: '2026-08-28T00:00:00Z',
  stopDate: '2026-11-28T23:59:59Z',
  endDate: '2026-11-28T23:59:59Z',

  endIfPurchased: false,

  trafficRate: 1,
  variants: [
    { code: abTestGlobalKey.groupControl, rate: 0.5 },
    { code: abTestGlobalKey.groupTreatment, rate: 0.5 },
  ],

  allowedDevices: [],
  allowedCountries: [],
  allowedStores: [ShopCode.SUN],
  allowedUrls: [
    'always-by-my-side-personalized-dog-plush-keychain-10308040426scl1cle1tu08nh02my04plk1_ipatudog00848',
    'mini-me-personalized-kid-plush-keychain-10325220426scl1cle1tr04cu03my04plk1_ipatukid00641',
    'love-cruising-personalized-cruising-magnet-10825040626scl1cle1ph08ph01du10mag1_ipatucrs00009',
    'the-funny-mystery-dumpling-for-kid-personalized-kid-keychain-10145270726scl1cle1tr04cu03li09kch1_ipatukid00904',
    'im-always-with-you-personalized-memorial-plush-ornament-10449180826scl1cle1tu08cu03my04plo1_ipatudth00422',
    'fly-attendant-custom-luggage-tag-personalized-fly-attendant-luggage-tag-10831140526scl1cle1tu08ph01li09slt1_ipatufad00002',
    'always-with-you-personalized-memorial-plush-keychain-10281030426scl1cle1tu08ha09my04plk1_ipatudth00288',
    'cruise-memory-personalized-cruising-magnet-10662260526scl1cle1ph08ph01tr18mag1_ipatucrs00007',
    'cute-fun-monster-pet-ornament-personalized-dog-plush-ornament-10286070926scl1tmm1tu08ha09li09plo1_ipatudog01364',
    'wash-your-hands-personalized-kid-pump-dispenser-10135050926scl1cle1tr04ha07du10sdp1_ipatukid01024',
    'gift-for-pet-owner-personalized-dog-classic-cap-10353050926scl1cle1tu08ha07ng21clc1_ipatudog01363',
    'custom-any-kid-photo-personalized-kid-curtain-tieback-10808070926scl1cle1tr04ha07du10tbk1_ipatukid01026',
    'toile-de-jouy-dog-personalized-dog-premium-3d-ornament-10265090926scl1cle1tu08nh02du10pdo1_ipatudog01369',
    'teacher-life-personalized-teacher-premium-3d-ornament-10660090926scl1cle1tr04ha07ha12pdo1_ipatutch00456',
    'love-gardening-personalized-gardening-3d-embossed-enamel-pin-10958100926scl1cle1tr04ha07an01eep1_ipatugdn00242',
    'merry-christmas-costume-personalized-kid-premium-faux-fur-pillow-10428160926scl1cle1tr04nh02tr15fsp2_ipatukid01040',
    'funny-colleagues-ornament-with-real-christmas-string-light-personalized-colleague-miniature-light-string-ornament-10731140926scl1cle1ph08nh02li09s064_ipatuclg00117',
    'celebrate-birthday-personalized-birthday-ornament-10400140926scl1cle1ph08ha07du10ton1_ipatubid00361',
    'strong-players-personalized-poker-whiskey-glass-10141140926scl1cle1ph08th07th12wkg1_ipatupok00012',
    'tis-the-season-personalized-football-whiskey-glass-10681140926scl1cle1tu08th07th12wkg1_ipatuftb00132',
    'love-baseball-personalized-baseball-premium-3d-ornament-10592140926scl1cle1tu08ha07ha12pdo1_ipatubsb00118',
    'the-best-hunter-personalized-hunting-premium-3d-ornament-10630140926scl1cle1tr04ha09ha12pdo1_ipatuhut00526',
    'custom-your-items-personalized-horoscope-classic-cap-10640140926scl1cle1ph08nh02my01clc1_ipatuhrs00046',
    'custom-nurse-item-personalized-nurse-classic-cap-10473140926scl1cle1tr04ha07my01clc1_ipatunur00298',
    'garden-glow-personalized-gardening-solar-acrylic-light-10152150926scl1cle1tr04cu03my04sol1_ipatugdn00244',
    'in-loving-memory-personalized-memorial-custom-shape-wooden-candle-holder-10385160926scl1cle1tu08cu03my04ccw1_ipatudth00452',
    'you-left-paw-prints-on-our-hearts-personalized-dog-acrylic-garden-sign-acrylic-plaque-sign-10198170926scl1cle1tu08cu03du10ags1_ipatudog01384',
    'its-my-birthday-personalized-birthday-3d-embossed-enamel-pin-10431230726scl1cle1ph08cu03li09eep1_ipatubid00325',
    'in-this-fight-no-one-stands-alone-personalized-breast-cancer-awareness-3d-embossed-enamel-pin-10120280726scl1cle1ph08nh02du10eep1_ipatubrc00216',
    'halloween-vibes-personalized-dog-3d-embossed-enamel-pin-10652120826scl1cle1tu08th07an01eep1_ipatudog01292',
    'halloween-vibes-personalized-witch-3d-embossed-enamel-pin-10175170826scl1cle1tr04ha07an01eep1_ipatuwic00613',
    'custom-suicide-prevention-blue-purple-sunflower-brooch-personalized-suicide-prevention-3d-embossed-enamel-pin-10565080826scl1cle1tr04cu03li09eep1_ipatuscp00022',
    'custom-flower-brooch-personalized-self-love-3d-embossed-enamel-pin-10128040826scl1cle1ph08cu03li09eep1_ipatuslv00138',
    'pencil-bow-personalized-teacher-3d-embossed-enamel-pin-10558110826scl1cle1tr04nh02th12eep1_ipatutch00441',
    'celebrating-freedom-1865-personalized-juneteenth-3d-embossed-enamel-pin-10277250526scl1cle1ph08ha07an01eep1_ipatujut00035',
    'couple-travel-memories-personalized-travelling-magnet-10791040626scl1cle1tr04nh02li09mag1_ipatutvl00038',
    'save-travelling-memories-personalized-travelling-magnet-10507170626scl1cle1tr04ha14ng21mag1_ipatutvl00057',
    'red-white-cruise-personalized-cruising-magnet-10463050626scl1cle1ph08cu03li09mag1_ipatucrs00010',
    'custom-from-any-photo-personalized-kid-premium-3d-ornament-10880060826scl1cle1tr04th07my04pdo1_ipatukid00939',
    'merry-woofmas-personalized-dog-diamond-painting-ornament-kit-10120040926scl1cle1tu08th07ha12dok1_ipatudog01359',
    'custom-any-sport-football-baseball-volleyball-basketball-personalized-football-ornament-10874050926scl1cle1tu08di03du10ton1_ipatuftb00122',
    'custom-from-any-photo-personalized-hunting-premium-3d-ornament-10390170726scl1cle1tr04th07li09pdo1_ipatuhut00475',
    'our-christmas-angel-personalized-memorial-premium-3d-ornament-10155310826scl1cle1tu08ha07my04pdo1_ipatudth00438',
    'merry-christmas-personalized-yellow-bear-premium-3d-ornament-10315230726scl1tmn1tr04nh02an01pdo1_ipatupoh00173',
    'in-loving-memory-personalized-memorial-premium-3d-ornament-10613060826scl1cle1tu08cu03my04pdo1_ipatudth00391',
    'christmas-dog-personalized-dog-ornament-10582060925scl1cle1tu08ha09du10ton1_ipatudog00361',
    'custom-any-photo-kid-car-toys-personalized-kid-premium-3d-ornament-10137040826scl1cle1tr04th07tr15pdo1_ipatukid00929',
    'my-1st-christmas-2026-personalized-newborn-premium-3d-ornament-10811240826scl1cle1tr04th07tr15pdo1_ipatunbn00033',
    'dog-mom-gift-pet-mom-dog-cat-lovers-personalized-dog-car-ornament-10824210426scl1cle1tu08cu03ng21con1_ipatudog00927',
    'cute-friends-any-character-personalized-yellow-bear-premium-3d-ornament-10884310826scl1tmn1tr04ha07tr15pdo1_ipatupoh00224',
    'little-christmas-personalized-kid-plush-ornament-10595060826scl1cle1tr04cu03my04plk1_ipatukid00942',
    'custom-from-any-photo-personalized-kid-premium-3d-ornament-10854030926scl1cle1tr04ha07li09pdo1_ipatukid01018',
    'little-elf-personalized-kid-plush-ornament-10328280826scl1cle1tr04ha07my04plo1_ipatukid01017',
    'keeping-the-lights-on-personalized-lineman-ornament-10916311025scl1cle1ph08nh02li09ton1_ipatulnm00019',
    'your-wings-were-ready-personalized-dog-custom-shape-ceramic-ornament-10937170926scl1cle1tu08nh02th12ccm1_ipatudog01386',
    'little-christmas-personalized-kid-plush-ornament-10438180826scl1cle1tr04nh02my04plo1_ipatukid00977',
    'custom-from-any-photo-gift-for-mermaid-loving-girls-personalized-kid-custom-shaped-ornament-10370160825scl1cle1tr04ha07li09cor1_ipatukid00208',
    'our-christmas-personalized-family-premium-3d-ornament-10917110926scl1cle1tr04nh02my04pdo1_ipatufml00445',
    'birthday-gift-personalized-birthday-diamond-painting-ornament-kit-10611040926scl1cle1ph08cu03du10dok1_ipatubid00356',
    'baby-1st-christmas-personalized-newborn-premium-3d-ornament-10278250826scl1cle1tr04nh02ng21pdo1_ipatunbn00035',
    'custom-from-any-photo-personalized-car-lover-ornament-10633051125scl1cle1tr04di03li09ton1_ipatucrl00002',
    'my-greatest-adventure-personalized-couple-car-ornament-10527290426scl1cle1tr04cu03li09con1_ipatucpl01099',
    'gift-for-dog-lover-personalized-dog-ornament-10378230825scl1cle1tu08di03ha13onm1_ipatudog00342',
    '10158210926scl1cle1ph08ha07tr15cgo1_ipatubet00229',
    '10362220926scl1cle1tu08ha07tr15ton1_ipatudth00465',
    '10328210926scl1cle1tr04ha07my04fcl1_ipatukid01052',
    '10974210926scl1cle1tr04cu03th12ccm1_ipatuhos00218',
    '10536220926scl1cle1tr04nh02du10ckj1_ipatuwic00642',
    '10924230926scl1tmr1tr04ha07my04hdt1_ipatucps00159',
    '10807230926scl1cle1tu08th07ha12fsp2_ipatudog01425',
    '10193230926scl1tmr1tr04nh02my04ptw1_ipatucps00161',
    '10101130126scl1cle1tu08cu03my04fsp1_ipatudth00179',
    '10628080626scl1tmn1ph08nh02tr18fsp2_ipatutsy00048',
    '10656050826scl1cle1ph08ha07my04ptw1_ipatubak00190',
    '10721171225scl1cle1tu08ha14tr15fsp1_ipatudth00125',
    '10911210726scl1cle1tu08cu03my04sdp1_ipatudog01241',
    '10114090126scl1cle1tu08ha07tr15fsp1_ipatudog00617',
    '10865130826scl1cle1tr04ha07my04ptw1_ipatuwic00607',
    '10354180326scl1cle1tu08cu03my04sdp1_ipatudog00798',
    '10186120826scl1cle1tu08th07an01scb1_ipatudog01294',
    '10825040626scl1cle1ph08ph01du10mag1_ipatucrs00009',
    '10112170826scl1cle1ph08ph01du10dmn1_ipatucrs00020',
    '10280240426scl1cle1tu08nh02an01aep1_ipatudog00949',
    '10616250226scl1cle1ph08th07tr01wkg1_ipaturtd00025',
    '10760260526scl1cle1tu08cu03an01clc1_ipatudog01033',
    '10934280726scl1cle1ph08cu03du10pub1_ipatubid00332',
    '10272130726scl1cle1tu08nh02my04sol1_ipatudog01231',
    '10178240226scl1cle1tu08ph01ha13fsp2_ipatudth00242',
    '10923210726scl1cle1tr04th07li09fsp2_ipatukid00868',
    '10544110526scl1cle1tr04th07li09sdp1_ipatufth00776',
    '10131180526scl1cle1tr04cu03my04sdp1_ipatukid00691',
    '10399090626scl1tmn1ph08nh02li09fsp2_ipatutsy00064',
    '10160280426scl1cle1tu08ha07my04sol1_ipatudog00956',
    '10391060426scl1cle1tu08ph01li09aep1_ipatudog00854',
    '10346050126scl1cle1tu08di03tr15fsp1_ipatudth00154',
    '10863160326scl1cle1tr04th07an01aep1_ipatunur00169',
    '10549120826scl1cle1ph08ha07my04ckj1_ipatubak00194',
    '10780190826scl1cle1tr04ha07an01ptw1_ipatucok00044',
    '10714060226scl1cle1tr04ph01my04fsp2_ipatucpl01038',
    '10364230626scl1tmn1tr04ha07ng21fsp2_ipatukid00773',
    '10630180526scl1cle1tr04cu03an01slt1_ipatutvl00037',
    '10447150726scl1tmn1tr04nh02tr15clc1_ipatucsm00008',
    '10370100626scl1tmr1tr04ha07my04ccw1_ipatucps00079',
    '10752120826scl1cle1tu08th07my04ptw1_ipatudog01293',
    '10128140526scl1cle1tr04nh02th12sdp1_ipatufth00820',
    '10748300926scl1cle1tr04nh02ha13plo1_ipatukid01103',
    '10953280926scl1tmr1tr04ha07my04pld1_ipatucps00168',
    '10396280926scl1cle1tr04ha07my04plo1_ipatukid01094',
    '10422280926scl1cle1tr04ha07li09plo1_ipatucpl01336',
    '10889290926scl1cle1tr04nh02ha12pdo1_ipatukid01098',
    '10983290926scl1cle1tr04th07ha12pdo1_ipatufml00463',
    '10395290926scl1cle1tu08cu03my04tbg1_ipatudog01456',
    '10771300926scl1cle1tr04th07th12rsb1_ipatucrc00084',
    '10269300926scl1cle1tr04cu03th12cgo1_ipatufml00470',
    '10179300926scl1cle1tr04cu03du10tbg1_ipatukid01101',
    '10703011026scl1cle1tr04ha07li09ton1_ipatucpl01352',
    '10656011026scl1cle1tr04ha07ng21pdo1_ipatucpl01356',
    '10134061026scl1cle1tr04cu03tr18sob1_ipatucrl00076',
    '10109061026scl1cle1tr04nh02tr15fsp2_ipatukid01124',
    '10883061026scl1cle1tr04cu03ha13pdo1_ipatufml00484',
    '10442051026scl1cle1tr04ha07ng21pdo1_ipatucpl01371',
    '10658051026scl1cle1tr04cu03ng21pdo1_ipatukid01121',
    '10889051026scl1cle1tr04nh02li09ton1_ipatufml00482',
    '10584061026scl1cle1tu08cu03du10tbg1_ipatudth00514',
    '10451061026scl1cle1tr04cu03my04fcl1_ipatukid01125',
    '10130061026scl1cle1tr04ha07li09ton1_ipatuhut00586',
    '10161061026scl1cle1tr04nh02tr15pdo1_ipatucpl01372',
    '10544071026scl1cle1tr04th07tr15sob1_ipatucpl01516',
    '10264061026scl1cle1tr04ha07an01wkg1_ipatuhut00574',
    '10130061026scl1cle1ph08ph01my04pdo1_ipatubak00218',
    '10274071026scl1cle1tu08nh02my04pdo1_ipatufsh00345',
    '10433121026scl1cle1tr04th07tr15pdo1_ipatukid01201',
    '10850131026scl1cle1tr04nh02tr15cgo1_ipatukid01203',
    '10501141026scl1cle1tu08nh02tr15fsp2_ipatudog01532',
    '10952141026scl1tmn1tr04nh02tr15fsp2_ipatukid01204',
    '10301141026scl1cle1tu08nh02tr15pld1_ipatudth00615',
    '10762161026scl1cle1tr04nh02tr15pdo1_ipatukid01207',
    '10678121026scl1cle1ph08cu03ha13pld1_ipatubak00240',
    '10661121026scl1cle1tu08ha07ha12pdo1_ipatubsb00125',
    '10348121026scl1cle1tu08ha07ha12pdo1_ipatuvlb00036',
    '10698121026scl1cle1tu08cu03th12tbg1_ipatudog01530',
    '10858121026scl1cle1tr04nh02li09pdo1_ipatutvl00101',
    '10565121026scl1cle1tr04cu03my04plk1_ipatunur00325',
    '10443131026scl1cle1tr04nh02tr18sob1_ipatufml00548',
    '10656141026scl1cle1tr04nh02th12tbg1_ipatunur00327',
    '10897151026scl1cle1ph08cu03my04ptw1_ipatubak00248',
    '10695151026scl1cle1tr04ha07ha12pdo1_ipatuhut00617',
    '10276151026scl1cle1tr04th07my04plo1_ipatufml00557',
  ],
}
